import appLogoImg from './app-logo.webp'
import rewardBgImg from './reward-bg.webp'
import vipImg from './vip.webp'
import coinsImg from './coins.webp'

import beansImg from './beans.webp'
import beansOffImg from './beans-off.webp'

import coinImg from './coin.webp'
import coinOffImg from './coin-off.webp'

import chatPassImg from './chat-pass.webp'
import chatPassOffImg from './chat-pass-off.webp'

import superChatPassImg from './super-chat-pass.webp'
import superChatPassOffImg from './super-chat-pass-off.webp'

import videoPassImg from './video-pass.webp'
import videoPassOffImg from './video-pass-off.webp'

import callPassImg from './call-pass.webp'
import callPassOffImg from './call-pass-off.webp'

import couponImg from './coupon.webp'
import couponOffImg from './coupon-off.webp'

export default {
  'app-logo': appLogoImg,
  'reward-bg': rewardBgImg,
  vip: vipImg,
  coins: coinsImg,

  beans: beansImg,
  'beans-off': beansOffImg,

  coin: coinImg,
  'coin-off': coinOffImg,

  'chat-pass': chatPassImg,
  'chat-pass-off': chatPassOffImg,

  'super-chat-pass': superChatPassImg,
  'super-chat-pass-off': superChatPassOffImg,

  'video-pass': videoPassImg,
  'video-pass-off': videoPassOffImg,

  'call-pass': callPassImg,
  'call-pass-off': callPassOffImg,

  coupon: couponImg,
  'coupon-off': couponOffImg,
}
